import type { Order } from '@ztechapps/common.contract'
import { OrderStatusEnum } from '@ztechapps/common.contract'

/**
 * A cancelled order is terminal — no payment, settle, delete, or refund may run on it
 * (cancel already auto-refunds its payments). Shared by the order-summary gates so the
 * `status === Cancelled` check isn't re-spelled at every payment control.
 */
export const isOrderCancelled = (order?: Order): boolean => order?.status === OrderStatusEnum.Cancelled
